export const ALERTS_WIZARD_ALERT_OPEN = 'alerts/ALERTS_WIZARD_ALERT_OPEN';
export const ALERTS_WIZARD_ALERT_OPEN_RESULT = 'alerts/ALERTS_WIZARD_ALERT_OPEN_RESULT';
export const ALERTS_WIZARD_ALERT_CLOSE = 'alerts/ALERTS_WIZARD_ALERT_CLOSE';
export const ALERTS_WIZARD_ALERT_SAVE = 'alerts/ALERTS_WIZARD_ALERT_SAVE';
export const ALERTS_WIZARD_ALERT_SAVE_RESULT = 'alerts/ALERTS_WIZARD_ALERT_SAVE_RESULT';
export const ALERTS_WIZARD_ALERT_TYPES_SUPPORTED = 'alerts/ALERTS_WIZARD_ALERT_TYPES_SUPPORTED';
export const ALERTS_WIZARD_ALERT_TYPES_SUPPORTED_RESULT = 'alerts/ALERTS_WIZARD_ALERT_TYPES_SUPPORTED_RESULT';
export const ALERTS_WIZARD_GET_ALERT = 'alerts/ALERTS_WIZARD_GET_ALERT';
export const ALERTS_WIZARD_GET_ALERT_RESULT = 'alerts/ALERTS_WIZARD_GET_ALERT_RESULT';
export const ALERTS_WIZARD_CLEAN_FIELDS = 'alerts/ALERTS_WIZARD_CLEAN_FIELDS';